/** *************************************************************************************************
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */ // Run `npm install --save classlist.js`.
/** Evergreen browsers require these. * */
import 'core-js/es/reflect';
/** Zone flags. Required to load before zone.js is loaded. * */
import '@dice/zone-flags';
/** *************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.
/** *************************************************************************************************
 * APPLICATION IMPORTS
 */
/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
// import 'intl';  // Run `npm install --save intl`.
/** *************************************************************************************************
 * User defined polyfills.
 */
/* eslint-disable-next-line import/extensions */
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js';

if (Element && !Element.prototype.matches) {
  const proto = Element.prototype;
  proto.matches = proto.msMatchesSelector || proto.webkitMatchesSelector;
}

if (typeof window.TextEncoder !== 'function') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require,@typescript-eslint/no-require-imports
  const encoding = require('text-encoding');
  window.TextEncoder = encoding.TextEncoder;
  window.TextDecoder = encoding.TextDecoder;
}

// eslint-disable-next-line @typescript-eslint/no-var-requires,global-require,import/newline-after-import,@typescript-eslint/no-require-imports
//const webSocket = require('websocket');
//window.WebSocket = webSocket.w3cwebsocket;

// eslint-disable-next-line
//(window as Window)['global'] = window;
